/** @jsxImportSource @emotion/react */
import {
  useEffect,
  useRef,
  useState,
  useContext,
  memo,
  useMemo,
  useCallback,
} from "react";
import Drawer from "@mui/material/Drawer";
import { Box } from "@mui/material";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import Stories from "react-insta-stories";
import { usePopupseen } from "../../hooks/services/PopupSeen";
import AppBar from "../../components/AppBar";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import Footer1 from "../../components/Footer/Footer";
import { useGetHomeScreenStyles } from "./index.styles";
import ReebokSVG from "../../icons/reebok";
import AdidasSvg from "../../icons/adidas";
import NikeSVG from "../../icons/nike";
import { appendAuthToken } from "../../utils/authSession";
import DrawerSearchContent from "./drawerSearchContent";
import { useGetNavItems } from "./appbarNav";
import { useHome } from "../../hooks/services/useHome";
import { useBrand } from "../../hooks/services/useBrand";
import { useCategory } from "../../hooks/services/useCategory";
import { useSubCategory } from "../../hooks/services/useSubCategory";
import { useMail } from "../../hooks/services/useMail";
import { useQueryClient } from "@tanstack/react-query";
import { useHomeQueries } from "../../hooks/useHomeQueries";
import {
  getCollection,
  getTotalCount,
  useActiveCampaigns,
} from "../../hooks/useCampaignQueries";
import { useDoYouKnow } from "../../hooks/useDoYouKnow";
import { useQuickOffers } from "../../hooks/useQuickOffers";
import { useCountry } from "../../hooks/services/useCountry";
import { UserContext } from "../../context/UserContext";
import { useRegions } from "../../hooks/services/religion";
import { useStateData } from "../../hooks/services/useStateData";
import { useCountyData } from "../../hooks/services/useCountyData";
import { useCityData } from "../../hooks/services/useCityData";
import Snackbar from "../../components/Snackbar";
import t from "../../theme";
import { Notificationconsumer } from "../../hooks/services/notifications";
import { usePopupseenuser } from "../../hooks/services/popupseenuser";
import { useProfile } from "../../hooks/services/Profile";
import { baseUrl } from "../../connections";
import { usePopAddslist } from "../../hooks/services/usePopupadds";
import { useModellist } from "../../hooks/services/useModels";
import { Useseenmodels } from "../../hooks/services/modelseen";
import { toast } from "react-toastify";
// Sub-components
import DrawerOfferCard from "./components/DrawerOfferCard";
import DrawerLocationCard from "./components/DrawerLocationCard";
import CategorySidebar from "./components/CategorySidebar";
import BrandCarousel from "./components/BrandCarousel";
import MailGrid from "./components/MailGrid";
import NotificationDrawer from "./components/NotificationDrawer";
import CampaignsPanel from "../Campaigns/components/CampaignsPanel";

const brandSvgs = [NikeSVG, ReebokSVG, AdidasSvg];
const DO_YOU_KNOW_TAB_UUID = "__do_you_know__";
const QUICK_OFFERS_TAB_UUID = "__quick_offers__";

const Home = () => {
  const [isRedeem, setIsRedeem] = useState(false);
  const [showpoints, setShowpoints] = useState(false);

  const location = useLocation();
  let drawerWidth = 240;
  const classes = useGetHomeScreenStyles();
  const navigate = useNavigate();
  const { userDetails, activeBrand, setActiveBrand } = useContext(UserContext);
  const [showDrawer, setShowDrawer] = useState(false);
  const [drawerContentRoute, setDrawerContentRoute] = useState("search");

  const [selectedOfferIndex, setSelectedOfferIndex] = useState();
  const [seconds, setSeconds] = useState(18);
  const [redeemedUuids, setRedeemedUuids] = useState(new Set());
  const offerDetailsCardRef = useRef(null);
  const { setPayload } = useHome();
  // Side-effect capabilities only — list data comes from useHomeQueries (below)
  const { setUpdateBrandFav } = useBrand();
  const { setUpdateMailFav, mailHTML, setMailURL, setReccurLoad } = useMail();
  // useCategory / useSubCategory are kept alive (they may have internal effects)
  // but their data and setters are no longer used — React Query drives all fetching.
  useCategory();
  useSubCategory();

  const { setPayloadsPopupseen } = usePopupseen();
  const { setPayloadsPopupseenuser } = usePopupseenuser();
  const { setusermodelpayload } = Useseenmodels();
  const { Setprofile, Profilelist } = useProfile();

  const [subCatActive, setSubCatActive] = useState("");
  const { countryList, setCountry } = useCountry();
  const { stateData, setStateData } = useStateData();
  const { ReligionData, setPayloadsreligion } = useRegions();
  const { countyData, setCountyData } = useCountyData();
  const { cityData, setCityData } = useCityData();
  const [selCountry, setSelCountry] = useState();
  const [selState, setSelState] = useState();
  const [selCounty, setSelCounty] = useState("");
  const [selCity, setSelCity] = useState();
  const [cityactive, setcityactive] = useState("");
  const [offerCard, setOfferCard] = useState({});
  const [selCategory, setSelCategory] = useState("");
  const userPickedCategoryRef = useRef(false);
  const userPickedSubcatRef = useRef(false);
  const [selBrand, setSelBrand] = useState([]);
  const [numPages, setNumPages] = useState(1);
  const [isAnimate, setIsAnimate] = useState(true);
  const [tabIndex, setTabIndex] = useState(0);
  const [showLeftDrawer, setShowLeftDrawer] = useState(true);
  const [showRightDrawer, setShowRightDrawer] = useState(false);
  const [locationCheck, setLocationCheck] = useState(false);
  const [redeemmsgs, setredeemmsgs] = useState(false);
  const [madelvideo, setmadelvideo] = useState("");
  const [showVideo, setShowVideo] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams(
    window.location.search,
  );
  let userdata = JSON.parse(localStorage.getItem("user"));
  const { Popupaddsdata, setPayloads } = usePopAddslist();
  const { modeldata, setModelPayloads } = useModellist();

  const Popupaddsdata1 = Popupaddsdata?.data;
  useEffect(() => {
    const data = {
      id: userdata?.uuid,
    };
    setPayloads(data);
    Setprofile(userdata?.uuid);
    setModelPayloads(userdata?.uuid);
  }, []);
  const [popupseen, setpopupseen] = useState(false);

  useEffect(() => {
    if (Profilelist?.data?.pop_up === false) {
      setShow(true);
    } else if (Profilelist?.data?.pop_up === true) {
      setShow(false);
    }
  }, [Profilelist]);

  const [currentAdIndex, setCurrentAdIndex] = useState(0);

  const goToNextAd = (data) => {
    setusermodelpayload({
      // uuid
      user_uuid: userdata?.uuid,
      modal_uuid: data,
    });
  };

  const goToPrevAd = () => {
    setCurrentAdIndex((prevIndex) =>
      prevIndex === 0 ? Popupaddsdata1?.length - 1 : prevIndex - 1,
    );
  };

  const [searchCat, setSearchCat] = useState(searchParams.get("cat"));
  const [searchBrand, setSearchBrand] = useState(searchParams.get("brand"));
  const [searchSubCat, setSearchSubCat] = useState(searchParams.get("sub"));
  const [popupdatadetails, setpopupdatadetails] = useState("");
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  const removeQueryParams = () => {
    // if (param) {
    // 👇️ delete each query param
    searchParams.delete("cat");
    searchParams.delete("brand");
    searchParams.delete("sub");

    // 👇️ update state after
    setSearchParams(searchParams);
    // }
  };

  const [show, setShow] = useState("");
  const [openShow, setOpenShow] = useState(0);
  useEffect(() => {
    setPayloadsreligion("name");
  }, []);
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    content: {
      background: "white",
      padding: "20px",
      borderRadius: "8px",
      position: "relative",
      width: "fit-content",
      maxWidth: "80%",
    },
    closeButton: {
      position: "absolute",
      top: "55px",
      // right: '10px',
      left: "117%",
      background: "none",
      border: "none",
      fontSize: "24px",
      cursor: "pointer",
    },
    Closebutton: {
      position: "absolute",
      top: "0px",
      right: "0px",
      // left: '117%',
      background: "none",
      border: "none",
      fontSize: "18px",
      cursor: "pointer",
    },
    body: {
      textAlign: "center",
    },
    image: {
      maxWidth: "100%",
      maxHeight: "80vh",
      backgroundColor: "black",
      height: "auto",
      objectFit: "contain",
    },
  };

  useEffect(() => {
    setSearchCat(searchParams.get("cat"));
    setSearchBrand(searchParams.get("brand"));
    setSearchSubCat(searchParams.get("sub"));
  }, [searchParams]);

  // toggle button

  const [seen, setseen] = useState("");

  // React Query: declarative data fetching with background polling.
  // Replaces the 4-step imperative payload chain (Steps 1\u20133 + Effect 10).
  const queryClient = useQueryClient();
  const {
    categoryList,
    isCategoryLoading,
    barndList,
    brandCount,
    isBrandLoading,
    subCategoryList,
    isSubCatLoading,
    mailList,
    mailCount,
    isMailLoading,
  } = useHomeQueries({
    selCity,
    selState,
    selCountry,
    selCounty,
    selCategory,
    selBrand,
    subCatActive,
    seen,
    userDetails,
  });
  const {
    data: activeCampaignsData,
    isLoading: isActiveCampaignsLoading,
    isError: isActiveCampaignsError,
  } = useActiveCampaigns({
    token: userDetails?.token,
    limit: 12,
    city: selCity,
  });
  const activeCampaigns = useMemo(
    () => getCollection(activeCampaignsData).slice(0, 12),
    [activeCampaignsData],
  );
  const activeCampaignCount = getTotalCount(
    activeCampaignsData,
    activeCampaigns.length,
  );
  const {
    doYouKnowData,
    isDoYouKnowLoading,
    doYouKnowError,
    isDoYouKnowConfigured,
  } = useDoYouKnow({ storeUuid: selBrand[0], token: userDetails?.token });
  const {
    quickOffersData,
    promotionsData,
    isQuickOffersLoading,
    quickOffersError,
  } =
    useQuickOffers({ storeUuid: selBrand[0], token: userDetails?.token });
  const hasDoYouKnowData = useMemo(() => {
    if (Array.isArray(doYouKnowData?.data))
      return doYouKnowData.data.length > 0;
    if (Array.isArray(doYouKnowData?.items))
      return doYouKnowData.items.length > 0;
    if (Array.isArray(doYouKnowData)) return doYouKnowData.length > 0;
    return Boolean(doYouKnowData);
  }, [doYouKnowData]);

  // Calculate total redeemed points and mail count from all mails where is_seen === 'true'
  const { totalRedeemedPoints, totalMailCount, unreadMailCount } =
    useMemo(() => {
      if (!mailList || mailList.length === 0)
        return {
          totalRedeemedPoints: 0,
          totalMailCount: 0,
          unreadMailCount: 0,
        };
      const redeemed = mailList.filter(
        (item) => item?.is_seen === "true" && item?.type === "paid",
      );
      const total = redeemed.reduce((sum, item) => sum + item?.amount, 0);
      return {
        totalRedeemedPoints: total,
        totalMailCount: mailList.length,
        unreadMailCount: mailList.filter((item) => item?.is_seen === "false")
          .length,
      };
    }, [mailList]);

  const homeTabs = useMemo(
    () => [
      { name: "Do you Know", uuid: DO_YOU_KNOW_TAB_UUID },
      ...subCategoryList,
      { name: "Coupons", uuid: QUICK_OFFERS_TAB_UUID },
    ],
    [subCategoryList],
  );
  const activeBrandList = useMemo(
    () => barndList?.filter((brand) => brand?.is_active) ?? [],
    [barndList],
  );

  // toggle button

  const isOfferContentDrawerActive = drawerContentRoute === "offerCard";

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  // Auto-select the first store on initial load when no brand is selected
  useEffect(() => {
    if (
      barndList &&
      barndList?.length > 0 &&
      selBrand?.length === 0 &&
      !searchBrand &&
      !location?.state?.id &&
      !(activeBrand?.length > 0)
    ) {
      const firstActiveBrand = barndList.find((b) => b?.is_active);
      if (firstActiveBrand) {
        setSelBrand([firstActiveBrand.uuid]);
      }
    }
  }, [barndList, selBrand]);

  const [open1, setOpen1] = useState(false);

  const handleClose1 = () => {
    setOpen1(false);
  };
  const handleClickOpen1 = (event) => {
    // sethistoryData(event)
    setOpen1(true);
  };

  const { noticationdata, setPayloadsdata, unread } = Notificationconsumer();
  useEffect(() => {
    setPayloadsdata(userdata?.uuid);
  }, [selBrand, selCategory]);
  const handleVideomadel = (item) => {
    setShowVideo(false);
    // handleNavLinksClick("offerCard", item);
  };

  const handleClose = (item) => {
    setShow(false);

    setPayloadsPopupseen({
      user_uuid: userdata?.uuid,
    });
    setusermodelpayload({
      // uuid
      user_uuid: userdata?.uuid,
      modal_uuid: item,
    });
    Popupaddsdata1.forEach((item) => {
      setPayloadsPopupseenuser({
        // uuid
        user_uuid: userdata?.uuid,
        popup_uuid: item?.uuid,
      });
    });
    setOpenShow(openShow + 1);
  };
  const popuplistuser = (item, event) => {
    event.preventDefault();
    setPayloads(userdata?.uuid);
    setPayloadsPopupseenuser({
      // uuid
      user_uuid: userdata?.uuid,
      popup_uuid: item,
    });
    // alert('ok ttd')
  };

  // Auto-select the first category when the list loads (or when URL params specify one).
  // React Query automatically fetches brands/subcats/mails once selCategory is set.
  useEffect(() => {
    if (!userDetails?.uuid) return;
    if (selCountry === undefined) return;

    if (searchCat) {
      setSelCategory(searchCat);
    } else if (location?.state?.data?.selCategory) {
      setSelCategory(location?.state?.data?.selCategory);
    } else if (categoryList?.length > 0 && !userPickedCategoryRef.current) {
      setSelCategory(categoryList[0]?.uuid);
    }
  }, [categoryList, searchCat]);

  const carouselContainerStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    width: "100%",
    maxWidth: "70vh",
    margin: "auto",
    height: "100%",
    overflow: "hidden",
    // padding: "0 48px",
  };

  // eslint-disable-next-line no-unused-vars
  const imageStyle1 = {
    height: "100%",
    maxWidth: "70vh",
    maxHeight: "100%",
    objectFit: "contain",
    display: "block",
    margin: "0 auto",
  };

  const storeLogoWrapper = {
    minWidth: "120px",
    maxWidth: "150px",
    height: "auto",
    paddingRight: "10px",
  };

  const storeLogoStyle = {
    width: "100%",
    height: "auto",
    border: "solid 6px rgba(255, 255, 255, 0.5)",
    borderRadius: "8px",
    background: "rgb(255, 255, 255)",
  };

  const mailContent = {
    color: "#fff",
    background: "rgba(0, 0, 0, 0.2)",
    padding: "10px 15%",
    display: "flex",
    justifyContent: "flex-start",
    width: "100%",
  };

  const arrowButtonStyle = {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    color: "white",
    border: "none",
    padding: "10px",
    cursor: "pointer",
    zIndex: 2,
    // right: '30px',
  };

  const prevButtonStyle = {
    ...arrowButtonStyle,
    // left: '10px',
    right: "100%",
  };

  const nextButtonStyle = {
    ...arrowButtonStyle,
    // right: '10px',
    left: "100%",
  };

  useEffect(() => {
    if (!userDetails?.uuid) return;
    // The user has manually picked a city (possibly in a different
    // country/state/county) via the city switcher — don't let this
    // poll-driven effect stomp that choice back to the home address.
    if (cityactive === true) return;
    if (location?.state?.data?.selCountry) {
      // navigated back with state — use it as-is
      setSelCountry(location?.state?.data?.selCountry);
      setSelState(location?.state?.data?.selState);
      setSelCounty(location?.state?.data?.selCounty);
      setSelCity(location?.state?.data?.selCity);
    } else {
      setSelCountry(userDetails?.address?.country || userDetails?.country);
      setSelState(userDetails?.address?.state || userDetails?.state);
      setSelCounty(userDetails?.address?.county || userDetails?.county);
      setSelCity(userDetails?.address?.city || userDetails?.city);
    }
  }, [userDetails, mailList, mailCount, cityactive]);

  const [mailSubscribeUpdate, setmailSubscribeUpdate] = useState(false);

  // Step 1 (simplified): initialize the page-level hooks that aren't covered by React Query.
  // setCatPayload removed — React Query now handles category fetching declaratively.
  useEffect(() => {
    if (!userDetails?.uuid) return;
    setPayload(`page_name=home`);
    setCountry(`page=0&limit=10&search=UnitedStates`);
  }, [
    selCountry,
    selState,
    selCounty,
    selCity,
    userDetails,
    mailSubscribeUpdate,
  ]);

  // Auto-select first available sub-category when the sub-category list changes.
  // React Query then fires the mail query because subCatActive is in its query key.
  useEffect(() => {
    if (isSubCatLoading) return;
    if (!subCategoryList?.length) return;
    // Don't override a tab the user has already manually selected.
    if (userPickedSubcatRef.current) return;

    // URL param takes priority
    if (searchSubCat) {
      const match = subCategoryList.find((s) => s.uuid === searchSubCat);
      if (match) {
        setSubCatActive(match.uuid);
        setTabindexs(0);
        return;
      }
    }

    // First subcat with mails available, or fall back to first in list
    const idx = subCategoryList.findIndex(
      (s) => s.is_mail_available === "true",
    );
    const first = subCategoryList[idx >= 0 ? idx : 0];
    setSubCatActive(first.uuid);
    setTabindexs(0);
  }, [isSubCatLoading, subCategoryList, searchSubCat]);

  const onTabChane = (sub_category_uuid) => {
    if (sub_category_uuid === DO_YOU_KNOW_TAB_UUID) {
      userPickedSubcatRef.current = true;
      setSearchSubCat("");
      return;
    }
    if (sub_category_uuid === QUICK_OFFERS_TAB_UUID) {
      userPickedSubcatRef.current = true;
      setSearchSubCat("");
      return;
    }
    userPickedSubcatRef.current = true;
    setSearchSubCat("");
    setSubCatActive(sub_category_uuid);
    // React Query automatically re-fetches mails because subCatActive is in the query key.
  };

  const [currentIndex, setCurrentIndex] = useState(0);

  const currentCard = mailList[currentIndex];
  const currentStore = currentCard?.brand[0];

  const [currentIndex1, setCurrentIndex1] = useState(0);
  const [seeMailMessage, setseeMailMessage] = useState({});
  const seeMailMessageData = useMemo(() => {
    let data = mailList[currentIndex1];
    setseeMailMessage(data);
    return data;
  }, [currentIndex1]);

  const handleNavLinksClick = (route, item) => {
    const isRedeemed = item?.is_seen === "true";

    if (item?.mime_type === "text/html") {
      const url = item?.image_url?.split("/");
      setMailURL({ html_url: url.slice(-1)[0] });
    }
    setIsAnimate(false);
    setOfferCard(item);
    if (route === "offerCard") {
      setDrawerContentRoute(route);
      setShowDrawer(true);
    } else if (route === "location" || route === "search") {
      setDrawerContentRoute(route);
      setShowDrawer(true);
    }

    {
      item?.type === "regular" &&
        route !== "search" &&
        !isRedeemed &&
        RedeemApiCall({
          user_uuid: userDetails?.uuid,
          mail_uuid: item?.uuid,
        });
    }
    setTimeout(() => {
      {
        item?.type !== "regular" &&
          route !== "search" &&
          !isRedeemed &&
          // Paid mails: redeem is now deferred until timer finishes
          // RedeemApiCall called from timer useEffect when countdown reaches 0
          void 0;
      }
    }, 2000);
  };

  const toggleDrawer = (event) => {
    if (
      (event.type === "keydown" &&
        (event.key === "Tab" || event.key === "Shift")) ||
      isOfferContentDrawerActive
    ) {
      return;
    }
    setShowDrawer(false);
  };

  const onFavouriteToggle = (e, brand_uuid) => {
    e.preventDefault();
    setUpdateBrandFav({
      user_uuid: userDetails?.uuid,
      brand_uuid: brand_uuid,
    });
  };

  const onFavouriteMailToggle = (e, mail_uuid, item) => {
    e.preventDefault();
    if (locationCheck) setLocationCheck(false);
    if (item?.city_uuid !== "") {
      if (item?.country_uuid === userDetails?.address?.country) {
        // && (item?.state_uuid === userDetails?.address?.state) &&
        // (item?.county_uuid === userDetails?.address?.county)
        // && (item?.city_uuid === userDetails?.address?.city)
        setUpdateMailFav({
          user_uuid: userDetails?.uuid,
          mail_uuid: mail_uuid,
        });
      } else {
        setLocationCheck(true);
      }
    } else if (item?.county_uuid !== "") {
      if (item?.country_uuid === userDetails?.address?.country) {
        // && (item?.state_uuid === userDetails?.address?.state) &&
        // (item?.county_uuid === userDetails?.address?.county)
        setUpdateMailFav({
          user_uuid: userDetails?.uuid,
          mail_uuid: mail_uuid,
        });
      } else {
        setLocationCheck(true);
      }
    } else if (item?.state_uuid !== "") {
      if (item?.country_uuid === userDetails?.address?.country) {
        // && (item?.state_uuid === userDetails?.address?.state)
        setUpdateMailFav({
          user_uuid: userDetails?.uuid,
          mail_uuid: mail_uuid,
        });
      } else {
        setLocationCheck(true);
      }
    } else if (item?.country_uuid !== "") {
      if (item?.country_uuid === userDetails?.address?.country) {
        setUpdateMailFav({
          user_uuid: userDetails?.uuid,
          mail_uuid: mail_uuid,
        });
      } else {
        setLocationCheck(true);
      }
    }
  };

  const [mailscroll, setmailscroll] = useState(false);

  const nextImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % mailList.length);
    setmailscroll(true);
    const currentCard = mailList[currentIndex + 1];
    const alreadyRedeemed =
      currentCard?.is_seen === "true" || redeemedUuids.has(currentCard?.uuid);

    // Only redeem regular mails immediately; paid mails wait for timer
    if (currentCard?.type === "regular" && !alreadyRedeemed) {
      RedeemApiCall({
        user_uuid: userDetails?.uuid,
        mail_uuid: currentCard?.uuid,
      });
    }
    setredeemmsgs(currentCard?.is_seen);
    setTimeout(() => {
      setredeemmsgs(false);
    }, 4500);
  };
  const [redeemtoast, setredeemtoast] = useState(true);
  const prevImage = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + mailList.length) % mailList.length,
    );
    setmailscroll(true);
    const currentCard = mailList[currentIndex - 1];
    const alreadyRedeemed =
      currentCard?.is_seen === "true" || redeemedUuids.has(currentCard?.uuid);

    // Only redeem regular mails immediately; paid mails wait for timer
    if (currentCard?.type === "regular" && !alreadyRedeemed) {
      RedeemApiCall({
        user_uuid: userDetails?.uuid,
        mail_uuid: currentCard?.uuid,
      });
    }
    setredeemmsgs(currentCard?.is_seen);
    setTimeout(() => {
      setredeemmsgs(false);
    }, 4500);
  };

  const onChangeHandler = (id, val) => {
    // setSelCategory('')
    // setSelBrand('')
    if (id === "country") {
      setSelCountry(val);
      setStateData(val);
      setSelState("");
      setSelCity("");
      setSelCounty("");
    }
    if (id === "state") {
      setSelState(val);
      setSelCounty("");
      setSelCity("");
      setCountyData(val);
    }
    if (id === "county") {
      setSelCounty(val);
      setSelCity("");
      setCityData(val);
    }
    if (id === "city") {
      setSelCity(val);
      // Mark the city as a manual override so the userDetails/poll-driven
      // effect above doesn't reset it back to the home address city.
      setcityactive(true);
    }
  };
  const [isFirstSelection, setIsFirstSelection] = useState(true);

  const onChangeCategoryHandler = (value) => {
    userPickedCategoryRef.current = true;
    userPickedSubcatRef.current = false; // reset so auto-select picks first relevant subcat
    setSelBrand([]);
    setSearchSubCat("");
    setSubCatActive(""); // reset so auto-select effect picks first subcat for new category
    setSelCategory((prev) => (prev !== value ? value : prev));
    if (showDrawer) setShowDrawer(false);
    // React Query automatically re-fetches brands, subcats, and mails because
    // selCategory is a key component of all three query keys.
    removeQueryParams();
  };

  useEffect(() => {
    // After a redeem event, invalidate the React Query caches so fresh counts and
    // availability flags are fetched without a manual payload poke.
    queryClient.invalidateQueries({ queryKey: ["home-categories"] });
    queryClient.invalidateQueries({ queryKey: ["home-brands"] });
    queryClient.invalidateQueries({ queryKey: ["home-mails"] });

    if (categoryList?.length > 0 && !userPickedCategoryRef.current) {
      setSelCategory(categoryList[0]?.uuid);
    }
  }, [isRedeem]);

  useEffect(() => {
    if (searchBrand) {
      const brand = [searchBrand];
      setSelBrand([...brand]);
      setTimeout(function () {
        onBrandSelect(true, searchBrand);
      }, 800);
    } else if (location?.state) {
      const brand = [location?.state?.id];
      setSelBrand([...brand]);
      setTimeout(function () {
        onBrandSelect(true, location?.state?.id);
      }, 800);
    } else if (activeBrand && activeBrand?.length > 0) {
      setSelBrand([...activeBrand]);
      setTimeout(function () {
        onBrandSelect(true, activeBrand[0]);
      }, 800);
      // Consume it — otherwise this stays set for the rest of the SPA
      // session and blocks the default-category auto-select on every future
      // visit to /home, since selBrand never goes back to empty on its own.
      setActiveBrand([]);
    } else if (selBrand && selBrand?.length > 0) {
      setTimeout(function () {
        onBrandSelect(true, selBrand[0]);
      }, 800);
    }
  }, [selCountry, searchBrand]);

  const onBrandSelect = (e, brandId, brandDetails) => {
    const brand = e ? [brandId] : selBrand.filter((el) => el !== brandId);
    setSelBrand([...brand]);
    // TanStack Query automatically fetches/clears doYouKnow and quickOffers
    // based on selBrand[0] changing — no manual load/reset needed.
    // React Query automatically re-fetches mails because selBrand is in the query key
    // (via effectiveBrands in useHomeQueries). No manual setMailPayload needed.
  };

  useEffect(() => {
    if (searchBrand || location?.state?.id || activeBrand?.length > 0) return;
    if (selBrand?.length > 0) return;
    if (activeBrandList.length !== 1) return;

    const [singleBrand] = activeBrandList;
    onBrandSelect(true, singleBrand?.uuid, singleBrand);
  }, [
    activeBrand,
    activeBrandList,
    location?.state?.id,
    searchBrand,
    selBrand,
  ]);

  const mailFilter = () => {
    if (mailList.length > 0) {
      const id = mailList[0]?.deals_type[0]?.uuid;
      const index = subCategoryList.findIndex((el) => el.uuid === id);
    }
  };

  const DefaultAddress = () => {
    setStateData(userDetails?.address?.country);
    // Resetting to the default address always wins over a manual city
    // override — clear the flag so the home city sticks going forward.
    setcityactive(false);
    if (userDetails?.address?.city != selCity) {
      setSelCity(userDetails?.address?.city);
    }
    if (userDetails?.address?.state != selState) {
      setCountyData(userDetails?.address?.state);
      setSelState(userDetails?.address?.state);
    }
    if (userDetails?.address?.county != selCounty) {
      setCityData(userDetails?.address?.county);
      setSelCounty(userDetails?.address?.county);
    }
  };

  const handleRedeem = () => {
    const messageDiv = document.getElementById("redeemMessage");
    if (messageDiv) {
      messageDiv.style.display = "block";

      // Hide the message after 15 seconds
      setTimeout(() => {
        messageDiv.style.display = "none";
      }, 15000);
    }
  };
  const handleBackButtonShow = () => {
    const messageDiv = document.getElementById("backbutton");
    if (messageDiv) {
      messageDiv.style.display = "none";

      // Hide the message after 15 seconds
      setTimeout(() => {
        messageDiv.style.display = "block";
      }, 15000);
    }
  };

  useEffect(() => {
    handleRedeem();
    handleBackButtonShow();
  }, []);

  // Countdown timer for paid mails — redeem API fires only when timer reaches 0
  useEffect(() => {
    if (
      showDrawer &&
      drawerContentRoute === "offerCard" &&
      currentCard?.type === "paid" &&
      currentCard?.is_seen === "false" &&
      !redeemedUuids.has(currentCard?.uuid)
    ) {
      setSeconds(18);
      const timer = setInterval(() => {
        setSeconds((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            // Timer finished — now actually redeem
            RedeemApiCall({
              user_uuid: userDetails?.uuid,
              mail_uuid: currentCard?.uuid,
            });
            // Mark as redeemed locally so timer won't show again
            setRedeemedUuids((prevSet) => {
              const next = new Set(prevSet);
              next.add(currentCard?.uuid);
              return next;
            });
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(timer);
    } else if (
      showDrawer &&
      drawerContentRoute === "offerCard" &&
      currentCard?.type === "paid" &&
      (currentCard?.is_seen === "true" || redeemedUuids.has(currentCard?.uuid))
    ) {
      // Already redeemed — ensure timer shows 0
      setSeconds(0);
    }
  }, [showDrawer, drawerContentRoute, currentIndex]);

  // Helper: determine if the content is a plain image (not video, not pdf, not html)
  const isPlainImage =
    currentCard &&
    !currentCard?.video_url &&
    currentCard?.mime_type !== "text/html" &&
    currentCard?.mime_type !== "application/pdf" &&
    currentCard?.image_url !== null;

  const handleCloseOfferModal = () => {
    const isPaid = currentCard?.type === "paid";
    const isUnseen =
      currentCard?.is_seen === "false" && !redeemedUuids.has(currentCard?.uuid);
    const isRedeeming = isPaid && isUnseen && seconds > 0;
    if (isRedeeming) return;
    setShowDrawer(false);
    BackMailLoad();
    setmailscroll(false);
    setShowVideo(false);
    setShowpoints(false);
    setredeemtoast(false);
  };

  const [subscribeshow, setSubscribeShow] = useState(false);
  const unSubscribeMail = (dataSub) => {
    const payload = {
      mail_uuid: dataSub?.uuid,
      user_uuid: userDetails?.uuid,
    };
    axios
      .put(`${baseUrl}/mail/unsubscribe`, payload, {
        headers: {
          "x-auth-token": userDetails?.token,
        },
      })
      .then((res) => {
        setSubscribeShow(false);
        setmailSubscribeUpdate(mailSubscribeUpdate ? false : true);
        setTimeout(() => {
          // Refresh category unread counts and mails via React Query
          queryClient.invalidateQueries({ queryKey: ["home-categories"] });
          queryClient.invalidateQueries({ queryKey: ["home-mails"] });
        }, 1000);
      })
      .catch((err) => {});
  };

  const handleOfferCardClick = (_item, idx) => {
    setCurrentIndex(idx);
    setmadelvideo(_item);
    setShowVideo(true);
    setSelectedOfferIndex(idx);
    handleNavLinksClick("offerCard", _item);
  };

  const renderDrawerContent = useCallback(() => {
    switch (drawerContentRoute) {
      case "search":
        return (
          <DrawerSearchContent
            classes={classes}
            brandList={barndList}
            mailList={mailList}
            categoryList={categoryList}
            onFavouriteToggle={onFavouriteToggle}
            onClose={toggleDrawer}
            onCatSelect={onChangeCategoryHandler}
            onSelect={onBrandSelect}
            selBrand={selBrand}
            showDrawer={() => setShowDrawer(false)}
            onFavouriteMailToggle={onFavouriteMailToggle}
            onUnsubscribeMail={unSubscribeMail}
            onOfferCardClick={handleOfferCardClick}
            subscribeshow={subscribeshow}
            setSubscribeShow={setSubscribeShow}
          />
        );

      case "location":
        return (
          <DrawerLocationCard
            classes={classes}
            offerDetailsCardRef={offerDetailsCardRef}
            countryList={countryList}
            stateData={stateData}
            countyData={countyData}
            cityData={cityData}
            selCountry={selCountry}
            selState={selState}
            selCounty={selCounty}
            selCity={selCity}
            userDetails={userDetails}
            onChangeHandler={onChangeHandler}
            onDefaultAddress={DefaultAddress}
          />
        );

      case "offerCard":
        return (
          <DrawerOfferCard
            currentCard={currentCard}
            currentStore={currentStore}
            mailList={mailList}
            currentIndex={currentIndex}
            mailHTML={mailHTML}
            redeemedUuids={redeemedUuids}
            seconds={seconds}
            isPlainImage={isPlainImage}
            classes={classes}
            onClose={handleCloseOfferModal}
            onNext={nextImage}
            onPrev={prevImage}
          />
        );

      default:
        return null;
    }
  }, [
    drawerContentRoute,
    classes,
    barndList,
    mailList,
    categoryList,
    onFavouriteToggle,
    toggleDrawer,
    onChangeCategoryHandler,
    onBrandSelect,
    selBrand,
    onFavouriteMailToggle,
    unSubscribeMail,
    handleOfferCardClick,
    subscribeshow,
    setSubscribeShow,
    currentCard,
    currentStore,
    currentIndex,
    mailHTML,
    redeemedUuids,
    seconds,
    isPlainImage,
    countryList,
    stateData,
    countyData,
    cityData,
    selCountry,
    selState,
    selCounty,
    selCity,
    userDetails,
  ]);

  const drawerContent = useMemo(
    () => renderDrawerContent(),
    [
      drawerContentRoute,
      classes,
      barndList,
      mailList,
      categoryList,
      onFavouriteToggle,
      toggleDrawer,
      onChangeCategoryHandler,
      onBrandSelect,
      selBrand,
      onFavouriteMailToggle,
      unSubscribeMail,
      handleOfferCardClick,
      subscribeshow,
      setSubscribeShow,
      currentCard,
      currentStore,
      currentIndex,
      mailHTML,
      redeemedUuids,
      seconds,
      isPlainImage,
      countryList,
      stateData,
      countyData,
      cityData,
      selCountry,
      selState,
      selCounty,
      selCity,
      userDetails,
    ],
  );

  const onDrawerHandler = (e) => {
    e.preventDefault();
    setShowLeftDrawer(!showLeftDrawer);
    drawerWidth = 0;
    // onChangeCategoryHandler(selCategory ? selCategory : '');
  };

  const onDrawerNotification = (e) => {
    e.preventDefault();
    removeQueryParams();
    setShowRightDrawer(!showRightDrawer);
  };

  const handleClickAway = () => {
    setShowRightDrawer(false);
  };
  // alert(showRightDrawer)
  const Allarray = [{ name: "All", uuid: "" }];

  const [tabIndexs, setTabindexs] = useState(0);
  const [change, setchange] = useState(false);
  const [checkseen, setCheckseen] = useState(false);

  const activefunct = (data) => {
    if (data === false) {
      setCheckseen(true);
      setseen("no");
      // React Query re-fetches mails with seen=no because `seen` is in the query key.
    } else {
      setCheckseen(false);
      setseen("");
      // React Query re-fetches mails with seen='' because `seen` is in the query key.
    }
  };

  const initialItemsToShow = 5;
  const [itemsToShow] = useState(initialItemsToShow);

  const navigationView = (link) => {
    navigate(link);
    // window.location.reload(false)
  };
  const NotificationUpdateseen = (notifiid) => {
    const payload = {
      notify_uuid: notifiid,
    };
    axios
      .put(`${baseUrl}/notification/update/seen`, payload, {
        headers: {
          "x-auth-token": userdata && userdata?.token,
        },
      })
      .then((res) => {
        // console.log(res)
      })
      .catch((err) => {
        // console.log(err)
      });
  };
  const contentStyle = {
    // background: "salmon",
    // width: "100%",
    padding: 20,
    color: "white",
  };
  const image = {
    display: "block",
    maxWidth: "60%",
    // maxHeight: "70%",
    marginLeft: "25%",
    borderRadius: 4,
  };
  const imageStyle = {
    cursor: "pointer", // Ensure the image has a pointer cursor
    // Add other styles as needed
  };

  const stories2 = Popupaddsdata1?.map((item, index) => ({
    content: ({ action, isPaused }) => (
      <div style={imageStyle} key={index}>
        <img style={image} src={item?.image} alt={`Story ${index}`} />
      </div>
    ),
  }));
  const handleStoryStart = (data1, index) => {
    // if (Popupaddsdata) {

    const data = {
      id: userdata?.uuid,
      indexId: index,
    };
    setPayloads(data);
    setPayloadsPopupseen({
      user_uuid: userdata?.uuid,
    });
    setPayloadsPopupseenuser({
      user_uuid: userdata?.uuid,
      popup_uuid: data1,
    });
    // }
  };
  const handleClick1 = (index) => {
    const data = {
      id: userdata?.uuid,
      indexId: index,
    };
    setPayloads(data);
    setOpen1(false);
  };

  const RedeemApiCall = (updateMailRedeem) => {
    setReccurLoad(false);
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    appendAuthToken(headers, userDetails?.token);

    const params = JSON.stringify(updateMailRedeem);

    const requestOptions = {
      method: "PUT",
      headers: headers,
      body: params,
      redirect: "follow",
    };
    // setIsRedeem(false)
    // setShowpoints(false)
    fetch(`${baseUrl}/mail/update/redeem`, requestOptions)
      .then(async (response) => {
        const res = await response.text();
        let data = {};
        try {
          data = res ? JSON.parse(res) : {};
        } catch {
          // Backend returned a plain string (not JSON) — preserve it as message
          data = { message: res || "" };
        }
        if (!response.ok) {
          return { ...data, _error: true, _status: response.status };
        }
        return data;
      })
      .then((result) => {
        if (result?._error) {
          const msg = `${result?.message || ""}`.toLowerCase();
          const alreadyRedeemed =
            result?.seen === true ||
            msg.includes("already") ||
            msg.includes("credited") ||
            msg.includes("success");
          if (!alreadyRedeemed) {
            toast.error(result?.message || "Redeem Unsuccessful!");
          }
          return;
        }
        if (result?.seen === false) {
          toast.success(result?.message || "Redeem successful!");
        }
      })
      .catch(() => {
        // Network error — silently ignore since redeem may have succeeded server-side
      });
  };

  const BackMailLoad = () => {
    setReccurLoad(true);
  };

  return (
    <>
      {modeldata?.data && modeldata.data.length > 0 && (
        <Modal show={show && openShow === 0} style={{ width: "100%" }}>
          {modeldata?.data?.map((item) => {
            return (
              <div key="" style={modalStyles.overlay}>
                <div style={modalStyles.content}>
                  <button
                    style={modalStyles.Closebutton}
                    onClick={() => handleClose(item?.uuid)}
                  >
                    X
                  </button>
                  <div
                    style={modalStyles.body}
                    onClick={() => goToNextAd(item?.uuid)}
                  >
                    <img
                      src={item?.image}
                      alt="MealBox Offer"
                      style={modalStyles.image}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </Modal>
      )}

      <Modal
        show={open1}
        style={{ marginTop: "5%", marginLeft: "19%" }}
        onHide={() => setOpen1(false)}
      >
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          {Popupaddsdata1?.length > 0 ? (
            <div className="stories-container">
              <Stories
                loop
                keyboardNavigation
                defaultInterval={10000}
                stories={stories2}
                width={1000} // Set the width
                height={550}
                // onClick={setPayloads(userdata?.uuid)}
                onStoryEnd={(s, st) => handleClick1(s)}
                // onAllStoriesEnd={(s, st) => console.log("all stories ended", s, st)}
                onStoryStart={(s, st) =>
                  handleStoryStart(Popupaddsdata1[s].uuid, s)
                }
                onAllStoriesEnd={(s) => handleClick1(s)}
              />
            </div>
          ) : (
            <div style={{ marginRight: "40%" }}>No Popup Adds</div>
          )}
        </div>
      </Modal>

      <div css={classes.pageContainer}>
        <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
          <AppBar
            navItems={
              useGetNavItems({
                handleNavLinksClick,
                selCountry,
                selState,
                selCity,
                setSelCity,
                setSelCountry,
                setSelState,
                setSelCounty,
                setcityactive,
                selCounty,
                selCategory,
                cityData,
                selBrand,
                setSelBrand,
                subCatActive,
                onDrawerNotification,
                handleClickOpen1,
                Popupaddsdata,
              }).navItems
            }
            onDrawerHandler={onDrawerHandler}
            drawerWidth={drawerWidth}
          />
          <Box css={classes.flex}>
            {(isCategoryLoading || (categoryList?.length ?? 0) > 0) && (
              <CategorySidebar
                classes={classes}
                categoryList={categoryList}
                isCategoryLoading={isCategoryLoading}
                selCategory={selCategory}
                showLeftDrawer={showLeftDrawer}
                drawerWidth={drawerWidth}
                onCategorySelect={onChangeCategoryHandler}
                onClose={() => setShowLeftDrawer(!showLeftDrawer)}
              />
            )}

            <Box
              component="main"
              sx={{
                flexGrow: 1,
                marginBottom: 2,
                width: showLeftDrawer
                  ? `calc(100% - ${drawerWidth}px)`
                  : "100%",
                marginLeft: showLeftDrawer ? 0 : `-${drawerWidth}px`,
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              }}
            >
              <CampaignsPanel
                campaigns={activeCampaigns}
                count={activeCampaignCount}
                isLoading={isActiveCampaignsLoading}
                isError={isActiveCampaignsError}
                onOpenCampaign={(uuid) =>
                  navigate(`/campaigns/${uuid}`, { state: { selCity } })
                }
                onViewAll={() => navigate("/campaigns", { state: { selCity } })}
                onViewBookings={() => navigate("/my-bookings")}
                compact
              />
              <BrandCarousel
                classes={classes}
                barndList={barndList}
                isBrandLoading={isBrandLoading}
                brandCount={brandCount}
                selBrand={selBrand}
                brandSvgs={brandSvgs}
                selCategory={selCategory}
                selCountry={selCountry}
                selState={selState}
                selCity={selCity}
                selCounty={selCounty}
                userDetails={userDetails}
                drawerContentRoute={drawerContentRoute}
                showDrawer={showDrawer}
                onBrandSelect={onBrandSelect}
                onFavouriteToggle={onFavouriteToggle}
              />
              <MailGrid
                classes={classes}
                tabs={homeTabs}
                subCategoryList={subCategoryList}
                isSubCatLoading={isSubCatLoading}
                isBrandLoading={isBrandLoading}
                mailList={mailList}
                mailCount={mailCount}
                isMailLoading={isMailLoading}
                subCatActive={subCatActive}
                tabIndexs={tabIndexs}
                setTabindexs={setTabindexs}
                checkseen={checkseen}
                onActivefunct={activefunct}
                totalRedeemedPoints={totalRedeemedPoints}
                totalMailCount={totalMailCount}
                unreadMailCount={unreadMailCount}
                subscribeshow={subscribeshow}
                setSubscribeShow={setSubscribeShow}
                selBrand={selBrand}
                selCategory={selCategory}
                selCountry={selCountry}
                selState={selState}
                selCity={selCity}
                selCounty={selCounty}
                userDetails={userDetails}
                onTabChange={onTabChane}
                onFavouriteMailToggle={onFavouriteMailToggle}
                onUnsubscribeMail={unSubscribeMail}
                onOfferCardClick={handleOfferCardClick}
                onMoreMailsClick={() =>
                  navigate(
                    `/moreMails?country_uuid=${selCountry}&state_uuid=${selState}&city_uuid=${selCity}&sub_category_uuid=${subCatActive}&user_uuid=${userDetails?.uuid}&county_uuid=${selCounty}&selCategory=${selCategory}&brand_uuid=${selBrand}&type=filter`,
                    {
                      state: {
                        selCountry,
                        selState,
                        selCity,
                        selCounty,
                        selCategory,
                        selBrand,
                      },
                    },
                  )
                }
                doYouKnowTabUuid={DO_YOU_KNOW_TAB_UUID}
                isDoYouKnowConfigured={isDoYouKnowConfigured}
                isDoYouKnowLoading={isDoYouKnowLoading}
                doYouKnowError={doYouKnowError}
                hasDoYouKnowData={hasDoYouKnowData}
                doYouKnowData={doYouKnowData}
                quickOffersTabUuid={QUICK_OFFERS_TAB_UUID}
                isQuickOffersLoading={isQuickOffersLoading}
                quickOffersError={quickOffersError}
                quickOffersData={quickOffersData}
                promotionsData={promotionsData}
              />
            </Box>
          </Box>
        </div>
        <div
          style={{
            flexShrink: 0,
            marginLeft: showLeftDrawer ? `${drawerWidth}px` : 0,
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          }}
        >
          {/* <AppFooter /> */}
          <Footer1 mailcount={mailCount} />
        </div>

        <Drawer
          anchor="top"
          open={showDrawer}
          onClose={toggleDrawer}
          PaperProps={{
            sx: classes.drawer,
          }}
          sx={[classes.drawerContainer, { zIndex: 1277 }]}
        >
          {drawerContent}
        </Drawer>

        {locationCheck && (
          <Snackbar
            message={"Favourite Not Possible"}
            isOpen={locationCheck}
            severity={"error"}
          />
        )}

        {showRightDrawer && (
          <NotificationDrawer
            showRightDrawer={showRightDrawer}
            drawerWidth={drawerWidth}
            noticationdata={noticationdata}
            itemsToShow={itemsToShow}
            onClose={() => setShowRightDrawer(false)}
            onClickAway={handleClickAway}
            onNavigate={navigationView}
            onMarkSeen={NotificationUpdateseen}
          />
        )}
      </div>
    </>
  );
};

export default memo(Home);
